import { useI18n } from 'hooks/useI18n';
import { getPublicPath } from 'utils/paths';
import SectionChart from '../shared/sectionChart/SectionChart';
import SectionHero from '../shared/sectionHero/SectionHero';
import Switcher from '../shared/switcher/Switcher';
import { AVERAGESALARYBYROLEANDEXPERIENCETABS } from './Benefits.constants';
import { StyledSection } from './Benefits.styled';
import LocationPreference from './LocationPreference';
import SalaryByEnglishLevel from './charts/SalaryByEnglishLevel';

const Benefits: React.FC = () => {
  const { t } = useI18n('developer-career-report-2024');
  const averageSalaryByRoleAndExperienceTabs =
    AVERAGESALARYBYROLEANDEXPERIENCETABS(t);

  return (
    <StyledSection>
      <SectionHero
        image={getPublicPath('/images/stateSector/2024/benefits.png')}
        title={t('mantechcar24.benefits.hero.title')}
        desc={t('mantechcar24.benefits.hero.desc')}
      />
      <SectionChart
        title={t('mantechcar24.benefits.location.title')}
        desc={t('mantechcar24.benefits.location.desc')}
        descExtra={t('mantechcar24.benefits.location.text')}
        shareId="locationpreference"
        emailSubject={t('mantechcar24.share-modal.location.email-subject')}
        emailMessage={t('mantechcar24.share-modal.location.email-text')}
        shareMessage={t('mantechcar24.share-modal.location.text')}
      >
        <LocationPreference />
      </SectionChart>

      <SectionChart
        title={t('mantechcar24.benefits.average-salary-role.title')}
        desc={t('mantechcar24.benefits.average-salary-role.desc')}
        descExtra={t('mantechcar24.benefits.average-salary-role.descExtra')}
        shareId="averagesalarybyroleandexperience"
        emailSubject={t(
          'mantechcar24.share-modal.average-salary-role.email-subject'
        )}
        emailMessage={t(
          'mantechcar24.share-modal.average-salary-role.email-text'
        )}
        shareMessage={t('mantechcar24.share-modal.average-salary-role.text')}
      >
        <Switcher
          tabsName={averageSalaryByRoleAndExperienceTabs.tabsName}
          tabs={averageSalaryByRoleAndExperienceTabs.tabs}
          label={averageSalaryByRoleAndExperienceTabs.label}
        />
      </SectionChart>
      <SectionChart
        title={t('mantechcar24.benefits.english.title')}
        desc={t('mantechcar24.benefits.english.desc')}
        descExtra={t('mantechcar24.benefits.english.descExtra')}
        shareId="salarybyenglishlevel"
        emailSubject={t('mantechcar24.share-modal.english.email-subject')}
        emailMessage={t('mantechcar24.share-modal.english.email-text')}
        shareMessage={t('mantechcar24.share-modal.english.text')}
      >
        <SalaryByEnglishLevel />
      </SectionChart>
    </StyledSection>
  );
};

export default Benefits;
